var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V30M36 18V26M34 8C38.8974 8 41.5463 8.74952 42.8642 9.33088C43.0398 9.40831 43.1275 9.44702 43.3808 9.68874C43.5326 9.83364 43.8098 10.2588 43.8811 10.4562C44 10.7855 44 10.9655 44 11.3255V32.8223C44 34.6398 44 35.5486 43.7274 36.0157C43.4502 36.4909 43.1828 36.7118 42.6639 36.8944C42.1537 37.0739 41.1239 36.876 39.0643 36.4803C37.6228 36.2033 35.913 36 34 36C28 36 22 40 14 40C9.10258 40 6.45373 39.2505 5.13577 38.6691C4.96025 38.5917 4.87249 38.553 4.6192 38.3113C4.46737 38.1664 4.19024 37.7412 4.11894 37.5438C4 37.2145 4 37.0345 4 36.6745L4 15.1777C4 13.3602 4 12.4514 4.27256 11.9843C4.5498 11.5091 4.81718 11.2882 5.33612 11.1056C5.84627 10.9261 6.87607 11.124 8.93566 11.5197C10.3772 11.7967 12.087 12 14 12C20 12 26 8 34 8ZM29 24C29 26.7614 26.7614 29 24 29C21.2386 29 19 26.7614 19 24C19 21.2386 21.2386 19 24 19C26.7614 19 29 21.2386 29 24Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB6);
export default __webpack_public_path__ + "static/media/b6.743e0b6c59f1cc6cce720b3d1189a26d.svg";
export { ForwardRef as ReactComponent };